var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shift-end-page page-content"},[_c('h2',[_vm._v("Entrega de Turno")]),_vm._v(" "),_c('app-shift-form',{attrs:{"is-start":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }